import React, { useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

/**Import Assets */
import styles from "./styles/ProtectedLayout.module.scss";
// import cssStyles from './styles/notification.module.css';

/**Import Custom Component */
import { WEB_ROUTES } from "../../constants";
import { baseRoute } from "../../Helper";
import Navbar from "./Navbar";

// Icons
import { FaUser } from "react-icons/fa";
import { FaFileInvoiceDollar } from "react-icons/fa6";
import { FaCalendarCheck } from "react-icons/fa6";
import { IoChatbubbles, IoNotifications } from "react-icons/io5";
import { MdDashboard, MdDesignServices, MdStorefront, MdAnalytics } from "react-icons/md";
import { RiDoubleQuotesL } from "react-icons/ri";
import { removeAccessToken } from "../../redux/slices/authSlice";
import { removeToken } from "../../Data/services/localStorageService";
import Toast from "../../Hooks/useToast";
import { useDispatch } from "react-redux";
import LogoutModal from "../Modals/LogoutModal";

const ALL_MENU_ITEMS = [
  { label: "Dashboard", icon: <MdDashboard /> },
  { label: "Analytics", icon: <MdAnalytics /> },
  { label: "User Management", icon: <FaUser /> },
  { label: "Agent Management", icon: <FaUser /> },
  { label: "Quote Management", icon: <RiDoubleQuotesL /> },
  { label: "Invoice Management", icon: <FaFileInvoiceDollar /> },
  { label: "Appointment Management", icon: <FaCalendarCheck /> },
  { label: "Services Management", icon: <MdDesignServices /> },
  { label: "Shop Management", icon: <MdStorefront /> },
  { label: "Send Notification", icon: <IoNotifications /> },
  { label: "Chat Support", icon: <IoChatbubbles /> },
];

/** Logged-in agent: dashboard + ops (settings: navbar only, next to logout). */
const AGENT_MENU_LABELS = new Set([
  "Dashboard",
  "Quote Management",
  "Invoice Management",
  "Appointment Management",
  "Chat Support",
]);

export default function ProtectedLayout({
  isSearchBar,
  selectedRoute,
  children,
}) {
  const portal = useSelector((state) => state.auth?.portal);
  const [collapsed, setCollapsed] = useState(window.innerWidth > 991);
  const locationPath = window.location.pathname;
  console.log(locationPath);

  const [logoutModal, setLogoutModal] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const items = useMemo(() => {
    if (portal === "agent") {
      return ALL_MENU_ITEMS.filter((item) => AGENT_MENU_LABELS.has(item.label));
    }
    return ALL_MENU_ITEMS;
  }, [portal]);

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };

  const handleMenuClose = () => {
    setCollapsed(false);
  };

  const handleViewProfile = () => {
    navigate(baseRoute(WEB_ROUTES.PROFILE));
  };

  const handleLogoutModalOpen = () => {
    setLogoutModal(true);
  };

  const handleLogoutModalClose = () => {
    setLogoutModal(false);
  };

  const handleLogout = () => {
    try {
      removeToken();
      dispatch(removeAccessToken());
      navigate("/account");
      window.location.reload();
      Toast("Logged Out Successfully", "success");
    } catch {
      Toast("An error occurred during log out", "error");
    }
  };

  return (
    <div className={styles.ProtectedLayout}>
      <div
        className={collapsed ? styles.background : ""}
        onClick={handleMenuClose}
      ></div>
      <div
        className={`${styles.menu} ${
          collapsed ? `${styles.collapsed} visible` : styles.notCollapsed
        }`}
        id="sider"
      >
        <div
          className={`${styles.logo} ${!collapsed ? styles.notCollapsed : ""}`}
          to={`${process.env.REACT_APP_DOMAIN_DIR}/dashboard`}
        >
          <img
            src={"/images/logo_name.png"}
            alt="Logo"
            className={`${
              collapsed ? styles.imageCollapsed : styles.imageNotCollapsed
            } image-fluid object-fit-contain`}
          />
        </div>

        {/* <div className={`${styles.drawer} ${collapsed ? styles.collapsed : ''}`}>

                    <span onClick={handleToggle}>
                        <BiLogOut />
                    </span>
                </div> */}

        {items.map(({ icon, label }, index) => {
          console.log(label);
          let LowerCaseLabel = label.toLowerCase().replace(/[^A-Z0-9]/gi, "-");
          return (
            <Link
              to={`${process.env.REACT_APP_DOMAIN_DIR}/${LowerCaseLabel}`}
              className={`${styles.item} ${
                locationPath === `/${LowerCaseLabel}` ? styles.active : ""
              }`}
              key={index}
            >
              <span style={{ fontSize: "20px", display: "flex" }}>
                {" "}
                {icon}{" "}
              </span>
              {collapsed ? <p>{label}</p> : ""}
            </Link>
          );
        })}
      </div>
      <div className={styles.routeContent}>
        {logoutModal ? (
          <LogoutModal
            handleLogoutModalClose={handleLogoutModalClose}
            data={""}
            onLogout={handleLogout}
          />
        ) : null}
        <Navbar
          isSearchBar={isSearchBar}
          handleToggle={handleToggle}
          onLogoutClick={handleLogoutModalOpen}
        />
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
}
